module.exports = __webpack_public_path__ + "static/media/intro-mobile-zh-HK.478b7315.png";